<template>
    <div class="p-3 container">  
        <div class="d-flex justify-content-between">
      <img src="../../public/img/consagradas_logo2.png" style="width: 200px;" alt="Logo de la compañía" class="logo">
     

      <div>
        <button class="btn btn-warning" v-if="lang=='es'" @click="lang = 'en'">Ver en Inglés</button>
        <button class="btn btn-warning" v-if="lang=='en'" @click="lang = 'es'">Ver en Español</button>
      </div>
    </div>
    <div v-if="lang=='es'">
      <h1>Términos y Condiciones de la App Móvil Consagradas</h1>
    
    <h2>1. Aceptación de los Términos</h2>
    <p>Al descargar, instalar o usar la aplicación móvil Consagradas, usted acepta estos Términos y Condiciones, así como nuestra Política de Privacidad. Si no está de acuerdo con estos términos, no debe usar la App.</p>
    <h2>2. Registro y Uso de la App</h2>
    <ul>
      <li><b>Proceso de Preregistro:</b>Para usar la App, debe registrarse proporcionando información precisa y completa. Su solicitud de registro está sujeta a aprobación. Nos reservamos el derecho de aprobar o rechazar cualquier solicitud de registro a nuestra discreción.</li>
      <li><b>Uso Aceptable:</b>La App está destinada para el uso personal y no comercial de las Consagradas. Usted se compromete a usar la App de manera responsable y de acuerdo con estos Términos y Condiciones.</li>
      <li><b>Notificaciones Push:</b>Al registrarse, acepta recibir notificaciones push sobre aniversarios, noticias, y otras actualizaciones relevantes. Puede administrar sus preferencias de notificación en la configuración de la App.</li>
    </ul>
    <h2>3. Contenido y Funciones</h2>
    <ul>
      <li><b>Intenciones y Peticiones:</b>Puede usar la App para publicar sus intenciones y peticiones. Usted es responsable del contenido que publique. No publique contenido ofensivo, difamatorio, o que viole los derechos de terceros.</li>
      <li><b>Foros:</b>La App ofrece foros para la discusión. Al participar en los foros, debe seguir las reglas de conducta establecidas. Nos reservamos el derecho de moderar el contenido del foro y eliminar cualquier publicación inapropiada.</li>
      <li><b>Feed de Noticias:</b>La App incluye un feed de noticias. Puede interactuar con las publicaciones dando "me gusta".</li>
      <li><b>Oraciones: </b>La App proporciona oraciones en diferentes idiomas.</li>
      <li><b>Credenciales: </b>Puede mostrar sus credenciales en la App y elegir si desea que sean públicas o privadas.</li>
      <li><b>Territorios y Comunidades: </b> La App incluye un listado de territorios y comunidades de Consagradas.</li>
    </ul>
    <p>Chami Rides se compromete a:</p>
    <ul>
      <li><b>Eliminación de Cuenta:</b>Puede eliminar su cuenta en cualquier momento a través de la configuración de la App.</li>
      <li><b>Recuperación de Cuenta:</b> Si olvida su contraseña, puede usar la función de recuperación de cuenta para restablecerla.</li>
    </ul>
    <h2>5.  Propiedad Intelectual</h2>
    <p>La App y todo su contenido, incluyendo el diseño, texto, imágenes, logotipos y software, son propiedad de "Consagradas" o de sus licenciantes y están protegidos por las leyes de propiedad intelectual.</p>
    <h2>6. Limitación de Responsabilidad</h2>
    <p>En la medida permitida por la ley, "Consagradas" no será responsable de ningún daño directo, indirecto, incidental, especial, consecuente o punitivo que surja de o esté relacionado con el uso de la App.</p>
    <h2>7. Modificaciones de los Términos</h2>
    <p>Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios se publicarán en la App y se le notificará. Su uso continuado de la App después de la publicación de los cambios constituirá su aceptación de los Términos y Condiciones modificados.</p>    
    </div>
    <div v-if="lang=='en'">
      <h1>Terms and Conditions of the Consagradas Mobile App</h1>
    
    <h2>1. Acceptance of Terms</h2>
    <p>By downloading, installing or using the Consagradas mobile application, you agree to these Terms and Conditions, as well as our Privacy Policy. If you do not agree to these terms, you should not use the App.  </p>
    <h2>2. Registration and Use of the App</h2>
    <ul>
      <li><b>Pre-registration Process: </b>To use the App, you must register by providing accurate and complete information. Your registration request is subject to approval. We reserve the right to approve or reject any registration request at our discretion.</li>
      <li><b>Acceptable Use:</b>The App is intended for the personal and non-commercial use of the Consagradas. You agree to use the App responsibly and in accordance with these Terms and Conditions.</li>
      <li><b>Push Notifications:</b>By registering, you agree to receive push notifications about anniversaries, news, and other relevant updates. You can manage your notification preferences in the App settings.</li>
    </ul>
    <h2>3. Content and Features</h2>
    <ul>
      <li><b>Intentions and Requests:</b>You can use the App to post your intentions and requests. You are responsible for the content you post. Do not post offensive, defamatory content, or content that violates the rights of third parties.</li>
      <li><b>Forums:</b>The App offers forums for discussion. When participating in the forums, you must follow the established rules of conduct. We reserve the right to moderate forum content and remove any inappropriate posts.</li>
      <li><b>News Feed:</b>The App includes a news feed. You can interact with posts by giving "likes".</li>
      <li><b>Prayers: </b>The App provides prayers in different languages.</li>
      <li><b>Credentials:</b>You can display your credentials in the App and choose whether you want them to be public or private.</li>
      <li><b>Territories and Communities: </b> The App includes a list of territories and communities of Consagradas.</li>
    </ul>
    <h2>4. User Accounts</h2>
    <p>Chami Rides se compromete a:</p>
    <ul>
      <li><b>Account Deletion: </b>You can delete your account at any time through the App settings.</li>
      <li><b>Account Recovery: </b>If you forget your password, you can use the account recovery feature to reset it.</li>
    </ul>
    <h2>5.  Intellectual Property</h2>
    <p>The App and all its content, including design, text, images, logos and software, are the property of "Consagradas" or its licensors and are protected by intellectual property laws.</p>
    <h2>6. Limitation of Liability</h2>
    <p>To the extent permitted by law, "Consagradas" will not be liable for any direct, indirect, incidental, special, consequential or punitive damages arising out of or related to the use of the App.</p>

    <h2>7. Modifications to the Terms</h2>
    <p>We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on the App and you will be notified. Your continued use of the App after the posting of changes will constitute your acceptance of the modified Terms and Conditions.</p>
      </div>

      <br>
      <div class="row">
      
      <div class="col-md-6">
        <button class="btn btn-primary" @click="$router.push('/politicas')">
          Ver Políticas de Privacidad
        </button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-primary" @click="$router.push('/cookies')">
          Ver Políticas de Cookies
        </button>
      </div>
    </div>
    <br>
    <br>
    </div>


    


</template>
<script>
export default {
  data() {
    return {
      lang: 'es' // Idioma predeterminado
    };
  }
};
</script>